import { v4 as uuidv4 } from "uuid";
export class PMOProjectTagModel {
    constructor() {
        this.projectId = uuidv4();
        this.tagId = uuidv4();
        this.tagName = "";
        this.tagColor = "";
        this.isInherited = false;
        this.assignedToAll = false;
    }
}
export default class PMOProjectTag extends PMOProjectTagModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
